// This query is used for enrichment data being fed into the contacts table
const enrichmentQuery = ({ includeDonorSearch = false } = {}) => {
  const gql = String.raw;

  const donorSearchFields = includeDonorSearch
    ? gql`
          donorsearch_scores_summary {
            ds_rating
            estimated_capacity
            largest_gift_upper_estimate
            total_gift_amount
            political_giving_amount
            real_estate_value
            sec_stock_value
          }
          donorsearch_ai_scores {
            type
            score_value
          }`
    : '';

  return gql`
    query ($ids: [BigInt!]) {
      contacts(ids: $ids) {
        id
        et_score {
          dds_score
        }
        enrichment {
          employments {
            company_name
            title
            start_month
            start_year
            start_date
            updated_at
            source
            status
            rejected
          }
          contact_locations {
            city
            state_code
            state_full
            metro_area
            country
            country_abbrev
            updated_at
          }
          wealth_attributes {
            net_worth
          }
          wealth_physical_assets {
            type
          }
          wealth_indicators {
            type
          }
          wealth_life_events {
            type
          }
          social_profiles {
            type
            followers
            url
          }
          employment_events {
            type
            source
            recorded_at
            updated_at
          }${donorSearchFields}
        }
      }
    }
  `;
};

export default enrichmentQuery;
